import { StringField, LinkField } from "../../types/types";
import { CardProps } from "../../types/types";
import { CardModel } from "../../lib/shared-models/card.model";
import {
  StoriesFields,
  StoriesProps,
  CategoryProps,
} from "./fields.definitions";
import {
  mockCardList,
  mockTitle,
  mockContent,
  mockLink,
  mockEyebrow,
} from "./mockCardList";

export class StoriesModel {
  private readonly fields?: StoriesFields;
  constructor(props: StoriesProps) {
    this.fields = props.fields;
  }

  get title(): StringField {
    return this.fields?.Title ?? mockTitle;
  }

  get content(): StringField {
    return this.fields?.Subtitle ?? mockContent;
  }

  get cards(): CardProps[] {
    const cardList = this.fields?.Cards ?? mockCardList;
    return cardList.map((el) => new CardModel(el).all);
  }

  get eyebrow(): StringField {
    return this.fields?.eyebrow ?? mockEyebrow;
  }

  get link(): LinkField {
    return this.fields?.link ?? mockLink;
  }

  get redbutton(): Boolean {
    return !!this.fields?.redbutton;
  }

  get categories(): CategoryProps[] {
    return this.fields?.Categories ?? [];
  }
}
